module.exports = __webpack_public_path__ + "frontend/images/homepage/carousel/mobile/1@2.png?a7d987fd79feb8478b6eafa6fda66e29";